exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label[data-v-226e1ed2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.info[data-v-226e1ed2]{font-size:13px;color:#909399}.cursor[data-v-226e1ed2]{cursor:pointer}\n", ""]);

// exports
